<template>
<el-dialog :title="viewFlag === 'view' ? '查看' :  !dataForm.id ? '新增' : '修改'" :close-on-click-modal="false" width="60%" :visible.sync="viewData.visible">
    <el-form :model="dataForm" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="0px" class="org-dialog-form">
        <el-tabs>
            <el-tab-pane key="1" label="基础信息">
                <div class="des_box">
                    <el-descriptions class="margin-top" :column="2" size="small" border style="margin-bottom: 15px;">
                        <el-descriptions-item label="32位唯一标识:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="zguid" style="margin-bottom: 0" size="small">
                                <span v-if="viewFlag === 'view'">{{dataForm.zguid}}</span>
                                <el-input v-else v-model="dataForm.zguid" placeholder="32位唯一标识" clearable></el-input>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="SRM协议号:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="zsrmh" style="margin-bottom: 0" size="small">
                                <span v-if="viewFlag === 'view'">{{dataForm.zsrmh}}</span>
                                <el-input v-else v-model="dataForm.zsrmh" placeholder="SRM协议号" clearable></el-input>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="OPTION:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="choose" style="margin-bottom: 0" size="small">
                                 <span v-if="viewFlag === 'view'">{{getChooseByValue(dataForm.choose)}}</span>
                                <el-select v-else v-model="dataForm.choose" placeholder="请选择">
                                    <el-option v-for="item in CHOOSE_TYPE" :key="item.value" :label="item.label" :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="供应商帐户号:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="lifnr" style="margin-bottom: 0" size="small">
                                <span v-if="viewFlag === 'view'">{{dataForm.lifnr}}</span>
                                <el-input v-else v-model="dataForm.lifnr" placeholder="供应商帐户号" clearable></el-input>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="工厂:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="werks" style="margin-bottom: 0" size="small">
                                <span v-if="viewFlag === 'view'">{{dataForm.werks}}</span>
                                <el-select v-else v-model="dataForm.werks" filterable placeholder="请选择工厂">
                                    <el-option v-for="item in factoryList" :key="item.factoryCode" :label="item.factoryDesc" :value="item.factoryCode">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="物料号:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="matnr" style="margin-bottom: 0" size="small">
                                <span v-if="viewFlag === 'view'">{{dataForm.matnr}}</span>
                                <el-input v-else v-model="dataForm.matnr" placeholder="物料号" clearable></el-input>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="采购组:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="ekgrp" style="margin-bottom: 0" size="small">
                                <span v-if="viewFlag === 'view'">{{dataForm.ekgrp}}</span>
                                <el-input v-else v-model="dataForm.ekgrp" placeholder="采购组"></el-input>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="采购组织:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="ekorg" style="margin-bottom: 0" size="small">
                                <span v-if="viewFlag === 'view'">{{dataForm.ekorg}}</span>
                                <el-select v-else v-model="dataForm.ekorg" filterable placeholder="请选择组织">
                                    <el-option v-for="item in purchaseOrgList" :key="item.purchaseOrgCode" :label="item.purchaseOrgName" :value="item.purchaseOrgCode">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="采购信息记录分类:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="esokz" style="margin-bottom: 0" size="small">
                                <span v-if="viewFlag === 'view'">{{getEsokzByValue(dataForm.esokz)}}</span>
                                <el-select v-else v-model="dataForm.esokz" placeholder="请选择">
                                    <el-option v-for="item in ESOKZ_TYPE" :key="item.value" :label="item.label" :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="责任销售员:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="verkf" style="margin-bottom: 0" size="small">
                                <span v-if="viewFlag === 'view'">{{dataForm.verkf}}</span>
                                <el-input v-else v-model="dataForm.verkf" placeholder="责任销售员"></el-input>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="供应商电话号码:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="telf1" style="margin-bottom: 0" size="small">
                                <span v-if="viewFlag === 'view'">{{dataForm.telf1}}</span>
                                <el-input v-else v-model="dataForm.telf1" placeholder="供应商电话号码"></el-input>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="采购单位:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="meins" style="margin-bottom: 0" size="small">
                                <span v-if="viewFlag === 'view'">{{dataForm.meins}}</span>
                                <el-input v-else v-model="dataForm.meins" placeholder="采购单位"></el-input>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="计划交货天数:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="aplfz" style="margin-bottom: 0" size="small">
                                <span v-if="viewFlag === 'view'">{{dataForm.aplfz}}</span>
                                <el-input v-else v-model="dataForm.aplfz" placeholder="计划交货天数"></el-input>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="税码:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="mwskz" style="margin-bottom: 0" size="small">
                                <span v-if="viewFlag === 'view'">{{dataForm.mwskz}}</span>
                                <el-select v-else v-model="dataForm.mwskz" filterable placeholder="请选择税码">
                                    <el-option v-for="item in taxCodeList" :key="item.taxCode" :label="item.taxRate" :value="item.taxCode">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="净价(不含税价格):" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="netpr" style="margin-bottom: 0" size="small">
                                <span v-if="viewFlag === 'view'">{{dataForm.netpr}}</span>
                                <el-input v-else v-model="dataForm.netpr" placeholder="净价(不含税价格)"></el-input>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="币别:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="waers" style="margin-bottom: 0" size="small">
                                <span v-if="viewFlag === 'view'">{{dataForm.waers}}</span>
                                <el-input v-else v-model="dataForm.waers" placeholder="币别"></el-input>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="价格单位:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="peinh" style="margin-bottom: 0" size="small">
                                <span v-if="viewFlag === 'view'">{{dataForm.peinh}}</span>
                                <el-input v-else v-model="dataForm.peinh" placeholder="价格单位"></el-input>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="转换分子:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="bpumz" style="margin-bottom: 0" size="small">
                                <span v-if="viewFlag === 'view'">{{dataForm.bpumz}}</span>
                                <el-input v-else v-model="dataForm.bpumz" placeholder="转换分子"></el-input>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="转换分母:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="bpumn" style="margin-bottom: 0" size="small">
                                <span v-if="viewFlag === 'view'">{{dataForm.bpumn}}</span>
                                <el-input v-else v-model="dataForm.bpumn" placeholder="转换分母"></el-input>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="是否暂估:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="kosrt" style="margin-bottom: 0" size="small">
                                <span v-if="viewFlag === 'view'">{{dataForm.kosrt}}</span>
                                 <el-select v-else v-model="dataForm.kosrt" placeholder="请选择">
                                    <el-option v-for="item in KOSRT_TYPE" :key="item.value" :label="item.label" :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="开始生效日期:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="datab" style="margin-bottom: 0" size="small">
                                <span v-if="viewFlag === 'view'">{{dataForm.datab}}</span>
                                <el-date-picker v-else v-model="dataForm.datab" type="datetime"  value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期">
                                </el-date-picker>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="有效截至日期:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="datbi" style="margin-bottom: 0" size="small">
                                <span v-if="viewFlag === 'view'">{{dataForm.datbi}}</span>
                                <el-date-picker v-else v-model="dataForm.datbi" type="datetime"  value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期">
                                </el-date-picker>
                            </el-form-item>
                        </el-descriptions-item>
                    </el-descriptions>
                </div>
            </el-tab-pane>
            <el-tab-pane :key="2" label="附件文件">
                <!-- TODO:上传下载 产看 需求文档 -->
                <FilesUpDown ref="FilesUpDown" :bizId="dataForm.id" :bizType="FILE_BIZ_TYPE"></FilesUpDown>
            </el-tab-pane>
        </el-tabs>
    </el-form>
    <el-row :gutter="40">
        <el-col :span="24" style="text-align:right;">
            <el-button size="small" @click="viewData.visible = false">
                取消
            </el-button>
            <el-button v-if="viewFlag !== 'view'" size="small" type="primary" @click="dataFormSubmit()">
                保存
            </el-button>
        </el-col>
    </el-row>
</el-dialog>
</template>

<script>
import {
    getPurchaseRoutePriceById,
    editPurchaseRoutePrice,
    createPurchaseRoutePrice,
    getFactoryList,
    getTaxCodeList,
    getPurchaseOrgList
} from '@/controller/systemData'
import { 
    ESOKZ_TYPE,
    getEsokzByValue, 
    CHOOSE_TYPE,
    getChooseByValue,
    KOSRT_TYPE,
    getKosrtByValue
} from "@/utils/const";
import moment from 'moment'
import FilesUpDown from "@/views/common/file-up-down";
// require('@/mock/mockContract');
export default {
    data() {
        return {
            FILE_BIZ_TYPE: 7,
            ESOKZ_TYPE : ESOKZ_TYPE,
            getEsokzByValue : getEsokzByValue,
            CHOOSE_TYPE : CHOOSE_TYPE,
            getChooseByValue : getChooseByValue,
            KOSRT_TYPE : KOSRT_TYPE,
            viewFlag: '',
            viewData: {
                visible: false,
                width: ''
            },
            dataList: [],
            factoryList: [],
            taxCodeList: [],
            purchaseOrgList: [],
            dataForm: {
                id: '',
                zguid: '',
                zsrmh: '',
                choose: '',
                lifnr: '',
                werks: '',
                matnr: '',
                ekgrp: '',
                ekorg: '',
                esokz: '',
                verkf: '',
                telf1: '',
                meins: '',
                aplfz: '',
                mwskz: '',
                netpr: '',
                waers: '',
                peinh: '',
                bpumz: '',
                bpumn: '',
                kosrt: '',
                datab: '',
                datbi: '',
            },
        }
    },
    components: {
        FilesUpDown //上传附件
    },
    mounted() {},
    methods: {
        init(data, id, viewFlag) {
            console.log(id)
            // this.dataForm = data ? data : this.dataForm
            this.viewFlag = viewFlag
            this.dataForm.id = id || 0
            this.viewData.visible = true
            this.$nextTick(() => {
                //初始化上传附件
                this.$refs.FilesUpDown.init(id, this.FILE_BIZ_TYPE, null);
                this.$refs['dataForm'].resetFields()
                if (this.dataForm && this.dataForm.id) {
                    getPurchaseRoutePriceById({}, this.dataForm.id).then(data => {
                        console.log(data)
                        if (data && data.code === '00') {
                            this.dataForm.id = data.body.id;
                            this.dataForm.zguid = data.body.zguid;
                            this.dataForm.zsrmh = data.body.zsrmh;
                            this.dataForm.choose = data.body.choose;
                            this.dataForm.lifnr = data.body.lifnr;
                            this.dataForm.werks = data.body.werks;
                            this.dataForm.matnr = data.body.matnr;
                            this.dataForm.ekgrp = data.body.ekgrp;
                            this.dataForm.ekorg = data.body.ekorg;
                            this.dataForm.esokz = data.body.esokz;
                            this.dataForm.verkf = data.body.verkf;
                            this.dataForm.telf1 = data.body.telf1;
                            this.dataForm.meins = data.body.meins;
                            this.dataForm.aplfz = data.body.aplfz;
                            this.dataForm.mwskz = data.body.mwskz;
                            this.dataForm.netpr = data.body.netpr;
                            this.dataForm.waers = data.body.waers;
                            this.dataForm.peinh = data.body.peinh;
                            this.dataForm.bpumz = data.body.bpumz;
                            this.dataForm.bpumn = data.body.bpumn;
                            this.dataForm.kosrt = data.body.kosrt;
                            this.dataForm.datab = data.body.datab;
                            this.dataForm.datbi = data.body.datbi;
                        }
                    })
                }
                // 工厂
                this.getFactoryList()
                // 税码
                this.getTaxCodeList()
                // 采购组织
                this.getPurchaseOrgList()
            })
        },
        // 下拉输入工厂
        getFactoryList() {
            getFactoryList({
                factoryCode: "",
                factoryDesc: "",
                address: "",
                post: "",
            }).then(data => {
                if (data && data.code === '00') {
                    this.factoryList = data.body;
                }
            });
        },
        // 下拉输入税码
        getTaxCodeList() {
            getTaxCodeList({
                taxCode: "",
                taxRate: "",
            }).then(data => {
                if (data && data.code === '00') {
                    this.taxCodeList = data.body;
                }
            });
        },
        // 下拉输入采购组织
        getPurchaseOrgList() {
            getPurchaseOrgList({
                purchaseOrgCode: "",
                purchaseOrgName: "",
            }).then(data => {
                if (data && data.code === '00') {
                    this.purchaseOrgList = data.body;
                }
            });
        },
        // 采购信息记录分类(0：入库结算 2：寄售 3：委外加工)
        typeFormat: function (value) {
            if (!value) {
                return "";
            }
            return getEsokzByValue(ESOKZ_TYPE, value);
        },
        // OPTION(C 新建/U修改)
        chooseTypeFormat: function (value) {
            if (!value) {
                return "";
            }
            return getChooseByValue(CHOOSE_TYPE, value);
        },
        // 是否暂估(暂估E/正式R)
        kosrtTypeFormat: function (value) {
            if (!value) {
                return "";
            }
            return getKosrtByValue(KOSRT_TYPE, value);
        },
        // 表单提交
        dataFormSubmit() {
            this.$refs['dataForm'].validate((valid) => {
                if (valid) {
                    let params = {
                        'id': this.dataForm.id || undefined,
                        'zguid': this.dataForm.zguid,
                        'zsrmh': this.dataForm.zsrmh,
                        'choose': this.dataForm.choose,
                        'lifnr': this.dataForm.lifnr,
                        'werks': this.dataForm.werks,
                        'matnr': this.dataForm.matnr,
                        'ekgrp': this.dataForm.ekgrp,
                        'ekorg': this.dataForm.ekorg,
                        'esokz': this.dataForm.esokz,
                        'verkf': this.dataForm.verkf,
                        'telf1': this.dataForm.telf1,
                        'meins': this.dataForm.meins,
                        'aplfz': this.dataForm.aplfz,
                        'mwskz': this.dataForm.mwskz,
                        'netpr': this.dataForm.netpr,
                        'waers': this.dataForm.waers,
                        'peinh': this.dataForm.peinh,
                        'bpumz': this.dataForm.bpumz,
                        'bpumn': this.dataForm.bpumn,
                        'kosrt': this.dataForm.kosrt,
                        'datab': this.dataForm.datab,
                        'datbi': this.dataForm.datbi,
                    }
                    if (this.dataForm.id) {
                        editPurchaseRoutePrice(params).then(data => {
                            if (data && data.code === '00') {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    onClose: () => {
                                        this.viewData.visible = false
                                        this.$emit('refreshDataList')
                                    }
                                })
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    } else {
                        createPurchaseRoutePrice(params).then(data => {
                            if (data && data.code === '00') {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    onClose: () => {
                                        this.viewData.visible = false
                                        this.$emit('refreshDataList')
                                    }
                                })
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    }
                }
            })
        },
        getStyle() {
            return 'width: 110px; text-align: right'
        },
        getStyle2() {
            return 'width: 314.4px;'
        }
    }
}
</script>

<style lang="scss" scoped>
.el-dialog__body {
    .org-dialog-form {
        width: 100%;
    }
}

.linetext {
    white-space: pre-line;
}
</style>
